import React, { useEffect, useState } from "react";
import { InfoToken } from "../../infoToken";
import Layout from "../../layouts/Layout";
import {
    rechercherGrapheMontantTransactions,
    rechercherGrapheMontantTransactionsParService,
    rechercherGrapheNombreTransactions,
    rechercherGrapheNombreTransactionsParService,
    statistiques,
} from "../../services/statistiques/StatistiquesRequest";
import Chart from "react-apexcharts";
import { profilUserConnected } from "../../services/utilisateurs/UtilisateursRequest";
import { convertNumber } from "../../convertToMoneyFormat";
import { Oval, ThreeDots } from "react-loader-spinner";
import { getDisplayMode } from "../../getDisplayMode";
import { useTranslation } from "react-i18next";

function Dashboard() {
    const { t } = useTranslation();
    const [stats, setstats] = useState([]);
    const [loading, setloading] = useState(false);
    const [datasGrapheNombreTransactions, setdatasGrapheNombreTransactions] =
        useState({
            options: {
                chart: {
                    id: "basic-bar",
                },
                fill: { colors: "#344b7b" },
                dataLabels: { enabled: false },
                title: {
                    text: "",
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: "",
                    },
                },
                yaxis: {
                    title: {
                        text: "",
                    },
                    labels: {
                        formatter: function (val, index) {
                            return val.toFixed(0);
                        },
                    },
                },
            },
            series: [
                {
                    name: "",
                    data: [],
                },
            ],
        });

    const [datasGrapheMontantTransactions, setdatasGrapheMontantTransactions] =
        useState({
            options: {
                chart: {
                    id: "basic-bar",
                },
                dataLabels: { enabled: false },
                fill: { colors: "#f9ba14" },
                title: {
                    text: "",
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: "",
                    },
                },
                yaxis: {
                    title: {
                        text: "",
                    },
                },
            },
            series: [
                {
                    name: "",
                    data: [],
                },
            ],
        });

    const [
        datasGrapheNombreTransactionsService,
        setdatasGrapheNombreTransactionsService,
    ] = useState({
        options: {
            title: {
                text: "Nombre de transactions global par service",
            },
            labels: [],
        },
        series: [],
    });

    const [
        datasGrapheMontantTransactionsService,
        setdatasGrapheMontantTransactionsService,
    ] = useState({
        options: {
            title: {
                text: "Montant des transactions global par service",
            },
            labels: [],
        },
        series: [],
    });

    const afficherGraphNombreTransactionService = () => {
        setloading(true);
        rechercherGrapheNombreTransactionsParService()
            .then((res) => {
                setloading(false);
                datasGrapheNombreTransactionsService.series = res.data.donnee.series;
                datasGrapheNombreTransactionsService.options.labels =
                    res.data.donnee.categories;
                setdatasGrapheNombreTransactionsService(
                    datasGrapheNombreTransactionsService
                );
            })
            .catch(() => {
                setloading(false);
            });
    };

    const afficherGraphMontantTransactionService = () => {
        rechercherGrapheMontantTransactionsParService().then((res) => {
            datasGrapheMontantTransactionsService.series = res.data.donnee.series;
            datasGrapheMontantTransactionsService.options.labels =
                res.data.donnee.categories;
            setdatasGrapheMontantTransactionsService(
                datasGrapheMontantTransactionsService
            );
        });
    };

    const afficherGraphNombreTransaction = () => {
        rechercherGrapheNombreTransactions().then((res) => {
            datasGrapheNombreTransactions.options.xaxis.categories =
                res.data.donnee.categories;
            datasGrapheNombreTransactions.options.title.text = t('dashboard.charts.monthTransactionsCount');
            datasGrapheNombreTransactions.options.xaxis.title.text = t('dashboard.charts.days');
            datasGrapheNombreTransactions.options.yaxis.title.text = t('dashboard.charts.transactionsCount');
            datasGrapheNombreTransactions.series[0].name = t('dashboard.charts.transactionsCount');
            datasGrapheNombreTransactions.series[0].data = res.data.donnee.series;
            setdatasGrapheNombreTransactions({...datasGrapheNombreTransactions});
        });
    };

    const afficherGraphMontantTransaction = () => {
        rechercherGrapheMontantTransactions().then((res) => {
            datasGrapheMontantTransactions.options.xaxis.categories =
                res.data.donnee.categories;
            datasGrapheMontantTransactions.options.title.text = t('dashboard.charts.monthTransactionsAmount');
            datasGrapheMontantTransactions.options.xaxis.title.text = t('dashboard.charts.days');
            datasGrapheMontantTransactions.options.yaxis.title.text = t('dashboard.charts.transactionsAmount');
            datasGrapheMontantTransactions.series[0].name = t('dashboard.charts.transactionsAmount');
            datasGrapheMontantTransactions.series[0].data = res.data.donnee.series;
            setdatasGrapheMontantTransactions({...datasGrapheMontantTransactions});
        });
    };

    const afficherStatistiques = () => {
        setloading(true);
        statistiques()
            .then((res) => {
                setloading(false);
                setstats(res.data.donnee);
            })
            .catch((error) => {
                setloading(false);
                console.log(error.response.data);
            });
    };

    useEffect(() => {
        afficherGraphNombreTransaction();
        afficherGraphMontantTransaction();
    }, []);

    useEffect(() => {
        afficherStatistiques();
        // afficherGraphNombreTransactionService();
        // afficherGraphMontantTransactionService();
    }, []);

    const rowListeReversementSolde = stats ? (
        <tr>
            <td>
                {stats && stats.montantPaiementGlobal
                    ? convertNumber(stats.montantPaiementGlobal)
                    : "0"}{" "}
                {t('common.currency')}
            </td>
            <td>
                {stats && stats.montantReversementAutomatiqueGlobal
                    ? convertNumber(stats.montantReversementAutomatiqueGlobal)
                    : "0"}{" "}
                {t('common.currency')}
            </td>
            <td>
                {stats && stats.montantReversementManuelGlobal
                    ? convertNumber(stats.montantReversementManuelGlobal)
                    : "0"}{" "}
                {t('common.currency')}
            </td>
            <td>
                {stats && stats.commissionGlobal
                    ? convertNumber(stats.commissionGlobal)
                    : "0"}{" "}
                {t('common.currency')}
            </td>
            <td>{stats.montantAReverser ? convertNumber(stats.montantAReverser) : "0"} {t('common.currency')}</td>
        </tr>
    ) : (
        <tr>
            <td colspan="3">
                <p
                    className="text-center"
                    style={{ paddingTop: "30px", paddingBottom: "30px" }}
                >
                    {t('dashboard.noReversal')}
                </p>
            </td>
        </tr>
    );

    return (
        <Layout>
            {getDisplayMode() === "CARD" && <div className="row" style={{ marginTop: "30px" }}>
                <div className="col-sm-4 mt-2">
                    <div
                        style={{
                            backgroundColor: "#fffbeb",
                            borderRadius: "8px",
                            padding: "8px",
                            border: "1px solid #fef3c7",
                        }}
                        className="card"
                    >
                        <div className="d-flex align-items-center mb-1">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#fef3c7",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-calendar-day"
                                    style={{ color: "#f57c00", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.todayTransactions')}
                                </h5>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex justify-content-between mb-2">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.payment')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombrePaiementDuJour === undefined
                                            ? 0
                                            : stats.nombrePaiementDuJour}{" "}
                                        / {stats.montantPaiementDuJour === undefined
                                            ? 0
                                            : convertNumber(stats.montantPaiementDuJour)}{" "}
                                        <span style={{ color: "#f57c00" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.reversal')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombreReversementDuJour === undefined
                                            ? 0
                                            : stats.nombreReversementDuJour}{" "}
                                        / {stats.montantReversementDuJour === undefined
                                            ? 0
                                            : convertNumber(stats.montantReversementDuJour)}{" "}
                                        <span style={{ color: "#f57c00" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4 mt-2">
                    <div
                        style={{
                            backgroundColor: "#ecfdf5",
                            borderRadius: "8px",
                            padding: "8px",
                            border: "1px solid #d1fae5",
                        }}
                        className="card"
                    >
                        <div className="d-flex align-items-center mb-1">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#e8f5e8",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-calendar-alt"
                                    style={{ color: "#4caf50", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.monthTransactions')}
                                </h5>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex justify-content-between mb-1">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.payment')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombrePaiementDuMois === undefined
                                            ? 0
                                            : stats.nombrePaiementDuMois}{" "}
                                        / {stats.montantPaiementDuMois === undefined
                                            ? 0
                                            : convertNumber(stats.montantPaiementDuMois)}{" "}
                                        <span style={{ color: "#4caf50" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.reversal')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombreReversementDuMois === undefined
                                            ? 0
                                            : stats.nombreReversementDuMois}{" "}
                                        / {stats.montantReversementDuMois === undefined
                                            ? 0
                                            : convertNumber(stats.montantReversementDuMois)}{" "}
                                        <span style={{ color: "#4caf50" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-4 mt-2">
                    <div
                        style={{
                            backgroundColor: "#f0f9ff",
                            borderRadius: "8px",
                            padding: "8px",
                            border: "1px solid #e0f2fe",
                        }}
                        className="card"
                    >
                        <div className="d-flex align-items-center mb-1">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#e3f2fd",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-globe"
                                    style={{ color: "#2196f3", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.globalTransactions')}
                                </h5>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex justify-content-between mb-2">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.payment')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombrePaiementGlobal === undefined
                                            ? 0
                                            : stats.nombrePaiementGlobal}{" "}
                                        / {stats.montantPaiementGlobal === undefined
                                            ? 0
                                            : convertNumber(stats.montantPaiementGlobal)}{" "}
                                        <span style={{ color: "#2196f3" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            color: "#666",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t('dashboard.reversal')}
                                    </p>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "#333",
                                        }}
                                    >
                                        {stats.nombreReversementGlobal === undefined
                                            ? 0
                                            : stats.nombreReversementGlobal}{" "}
                                        / {stats.montantReversementGlobal === undefined
                                            ? 0
                                            : convertNumber(stats.montantReversementGlobal)}{" "}
                                        <span style={{ color: "#2196f3" }}>{t('common.currency')}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            {getDisplayMode() === "CARD" &&
                (<div className="row mt-3">
                    <div className="col-sm-6">
                        <div
                            style={{
                                backgroundColor: "#fff4e6",
                                borderRadius: "8px",
                                padding: "10px",
                                border: "1px solid #fed7aa",
                            }}
                            className="card"
                        >
                            <div className="d-flex align-items-center">
                                <div
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "100px",
                                        backgroundColor: "#fed7aa",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "20px",
                                    }}
                                >
                                    <i
                                        className="fas fa-dollar-sign"
                                        style={{ color: "#ea580c", fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h5
                                        style={{
                                            margin: 0,
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            color: "#333",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        {t('dashboard.globalTransactionCost')}
                                    </h5>
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            color: "#ea580c",
                                        }}
                                    >
                                        {stats.montantTransactionGlobal === undefined
                                            ? 0
                                            : convertNumber(stats.montantTransactionGlobal)}{" "}
                                        {t('common.currency')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 h-100">
                        <div
                            style={{
                                backgroundColor: "#faf5ff",
                                borderRadius: "8px",
                                padding: "10px",
                                border: "1px solid #fae8ff",
                            }}
                            className="card"
                        >
                            <div className="d-flex align-items-center">
                                <div
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "100px",
                                        backgroundColor: "#f3e5f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "20px",
                                    }}
                                >
                                    <i
                                        className="fas fa-wallet"
                                        style={{ color: "#9c27b0", fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h5
                                        style={{
                                            margin: 0,
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            color: "#333",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        {localStorage.getItem("role") === "ROLE_ADMIN_PRESTATAIRE" ? t('dashboard.balance') : t('dashboard.totalAmountToReverse')}
                                    </h5>
                                    <div className="d-flex align-items-center">
                                        {stats.montantAReverser === undefined ||
                                            isNaN(stats.montantAReverser) ? (
                                            <ThreeDots color="#9c27b0" height={30} width={30} />
                                        ) : (
                                            <p
                                                style={{
                                                    margin: 0,
                                                    fontSize: "24px",
                                                    fontWeight: "700",
                                                    color: "#9c27b0",
                                                }}
                                            >
                                                {convertNumber(Math.floor(stats.montantAReverser))} {t('common.currency')}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
            }

            {getDisplayMode() === "TABLEAU" && localStorage.getItem("role") !== "ROLE_ADMIN" && <div className="table-responsive">
                <table className="table table-bordered celled padded">
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: "#F0F0F0" }}>
                                {t('dashboard.totalPayment')}
                            </th>
                            <th style={{ backgroundColor: "#F0F0F0" }}>
                                {t('dashboard.autoReversals')}
                            </th>
                            <th style={{ backgroundColor: "#F0F0F0" }}>
                                {t('dashboard.manualReversals')}
                            </th>
                            <th style={{ backgroundColor: "#F0F0F0" }}>
                                {t('dashboard.skanpayCommission')}
                            </th>
                            <th style={{ backgroundColor: "#F0F0F0" }}>{t('dashboard.balance')}</th>
                        </tr>
                    </thead>
                    <tbody>{rowListeReversementSolde}</tbody>
                </table>
                {loading && (
                    <div className="d-flex justify-content-center">
                        <Oval
                            width={30}
                            height={30}
                            color="#344b7b"
                            visible={loading}
                        />
                    </div>
                )}
            </div>}

            {/* REVERSEMENT */}
            <div className="row mt-3 mb-3 gap-2">
                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <div
                        style={{
                            backgroundColor: "#fffbeb",
                            borderRadius: "8px",
                            padding: "14px",
                            border: "1px solid #fef3c7",
                            minWidth: "280px",
                        }}
                        className="col"
                    >
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#fef3c7",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-calendar-day"
                                    style={{ color: "#f57c00", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.todayReversal')}
                                </h5>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.manual')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#333",
                                    }}
                                >
                                    {!stats.montantReversementManuelDuJour
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementManuelDuJour
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.automatic')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#f57c00",
                                    }}
                                >
                                    {!stats.montantReversementAutomatiqueDuJour
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementAutomatiqueDuJour
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <div
                        style={{
                            backgroundColor: "#ecfdf5",
                            borderRadius: "8px",
                            padding: "14px",
                            border: "1px solid #d1fae5",
                            minWidth: "280px",
                        }}
                        className="col"
                    >
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#e8f5e8",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-calendar-alt"
                                    style={{ color: "#4caf50", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.monthReversal')}
                                </h5>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.manual')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#333",
                                    }}
                                >
                                    {!stats.montantReversementManuelDuMois
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementManuelDuMois
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.automatic')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#4caf50",
                                    }}
                                >
                                    {!stats.montantReversementAutomatiqueDuMois
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementAutomatiqueDuMois
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                    <div
                        style={{
                            backgroundColor: "#f0f9ff",
                            borderRadius: "8px",
                            padding: "14px",
                            border: "1px solid #e0f2fe",
                            minWidth: "280px",
                        }}
                        className="col"
                    >
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: "38px",
                                    height: "38px",
                                    borderRadius: "100px",
                                    backgroundColor: "#e3f2fd",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                }}
                            >
                                <i
                                    className="fas fa-globe"
                                    style={{ color: "#2196f3", fontSize: "14px" }}
                                ></i>
                            </div>
                            <div>
                                <h5
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: "#333",
                                    }}
                                >
                                    {t('dashboard.globalReversal')}
                                </h5>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.manual')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#333",
                                    }}
                                >
                                    {!stats.montantReversementManuelGlobal
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementManuelGlobal
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                            <div>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        color: "#666",
                                        fontWeight: "500",
                                    }}
                                >
                                    {t('dashboard.automatic')}
                                </p>
                                <p
                                    style={{
                                        margin: 0,
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#4caf50",
                                    }}
                                >
                                    {!stats.montantReversementAutomatiqueGlobal
                                        ? 0
                                        : convertNumber(
                                            stats.montantReversementAutomatiqueGlobal
                                        )}{" "}
                                    {t('common.currency')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="row bg-white mx-1 mb-3" style={{ marginTop: "30px", paddingBottom: "80px" }}>
                {datasGrapheNombreTransactions.options.xaxis.categories.length !==
                    0 && (
                        <div style={{ marginTop: "30px", backgroundColor: "#f5f5f4", borderRadius: "8px", padding: "10px", border: "1px solid #fae8ff" }}>
                            <Chart
                                options={datasGrapheNombreTransactions.options}
                                series={datasGrapheNombreTransactions.series}
                                type="bar"
                                width="100%"
                                height="400px"
                            />
                        </div>
                    )}
                {datasGrapheMontantTransactions.options.xaxis.categories.length !==
                    0 && (
                        <div style={{ marginTop: "30px", backgroundColor: "#fefce8", borderRadius: "8px", padding: "10px", border: "1px solid #fef9c3" }}>
                            <Chart
                                options={datasGrapheMontantTransactions.options}
                                series={datasGrapheMontantTransactions.series}
                                type="bar"
                                width="100%"
                                height="400px"
                            />
                        </div>
                    )}
            </div>
        </Layout>
    );
}

export default Dashboard;
